<template>
  <div class="table-sort">
    <button class="table-sort__button" :class="{ 'table-sort__button--selected': selectedAsc }" @click="sortAsc">
      <oie-use-svg svg="caret" css-classes="svg--90-negative"></oie-use-svg>
    </button>

    <button class="table-sort__button" :class="{ 'table-sort__button--selected': selectedDesc }" @click="sortDesc">
      <oie-use-svg svg="caret" css-classes="svg--90"></oie-use-svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      default: ''
    },
    productId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    selectedAsc: false,
    selectedDesc: false
  }),
  mounted() {
    this.subscribe('sort' + this.productId, (path, order) => {
      if(this.path !== path) {
        this.selectedAsc = false
        this.selectedDesc = false
      }
    })
  },
  methods: {
    sortAsc() {
      this.selectedAsc = true
      this.selectedDesc = false
      this.publish('sort' + this.productId, this.path, 'asc')
    },
    sortDesc() {
      this.selectedAsc = false
      this.selectedDesc = true
      this.publish('sort' + this.productId, this.path, 'desc')
    }
  }
}
</script>

<style lang="scss">
.table-sort {
  position: absolute;
  top: 50%;
  right: measure(quarter);
  // bottom: measure(quarter);
  display: flex;
  flex-direction: column;
  width: 0.625rem;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-50%);

  &:hover {
    cursor: pointer;
  }
}

.table-sort__button {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  height: .85rem;
  padding: 0;
  background-color: transparent;
  color: color(disabled-item);

  &:hover {
    cursor: pointer;
    color: color(enabled-item-gray);
  }
}

.table-sort__button--selected {
  color: color(enabled-item-gray);
}

.table-sort__button svg {
  width: 0.625rem;
  height: 0.625rem;
}
</style>
